import RomeAssetsTable from "./RomeAssetsTable";

export default RomeAssetsTable;
